import { useRef } from 'react';

import type { ContactFormatted } from '@proton/shared/lib/interfaces/contacts/Contact';
import type { VCardContact } from '@proton/shared/lib/interfaces/contacts/VCard';

import { SortableList } from '../../../../components/dnd/SortableList';
import TableBody from '../../../../components/table/TableBody';
import MergeTableBodyRow from './MergeTableBodyRow';

interface Props {
    contacts: ContactFormatted[];
    vcardContacts?: VCardContact[];
    highlightedID: string;
    isChecked: { [ID: string]: boolean };
    beDeleted: { [ID: string]: boolean };
    onClickCheckbox: (ID: string) => void;
    onClickDetails: (ID: string) => void;
    onToggleDelete: (ID: string) => void;
    onSortEnd: ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => void;
}

const MergeTableBody = ({
    contacts,
    highlightedID,
    isChecked,
    beDeleted,
    onClickCheckbox,
    onClickDetails,
    onToggleDelete,
    onSortEnd,
    ...rest
}: Props) => {
    const containerRef = useRef<HTMLTableSectionElement>(null);

    return (
        <TableBody {...rest} data-testid="merge-model:merge-table" ref={containerRef}>
            <SortableList onSortEnd={onSortEnd} containerRef={containerRef}>
                {contacts.map((Contact, index) => (
                    <MergeTableBodyRow
                        key={Contact.ID}
                        ID={Contact.ID}
                        index={index}
                        Contact={Contact}
                        highlightedID={highlightedID}
                        isChecked={isChecked}
                        beDeleted={beDeleted}
                        onClickCheckbox={onClickCheckbox}
                        onClickDetails={onClickDetails}
                        onToggleDelete={onToggleDelete}
                    />
                ))}
            </SortableList>
        </TableBody>
    );
};

export default MergeTableBody;
